import { AnalyticsContext } from '@carvana/eventable-clickstream';
import classNames from 'classnames';
import dynamic from 'next/dynamic';
import { useContext, memo } from 'react';
import { useSelector } from 'react-redux';
import HeroContext from '@/vdp/Hero/HeroContext';
import SpinnerLoader from '@/vdp/Hero/SpinnerLoaderMfe';
import { SPINNER_ENGAGED } from '~/constants/Events';
import Sections from '~/constants/sections';
import GlobalContext from '~/context/vdp/GlobalContext';
import { getIsMobileCapture, getIsSpinnerDisabled } from '~/selectors';
import debounce from '~/utilities/debounce';
import { Container, Wrapper } from './Spinner.styles';
import StaticVehicle from '../StaticVehicle';

const HeroHeader = dynamic(
  () => import(/* webpackChunkName: "HeroHeader" */ '@/vdp/HeroHeader')
);

function Spinner() {
  const { trackEvent } = useContext(AnalyticsContext);
  const { spinnerReady } = useContext(GlobalContext);
  const { hasSpinnerOverflow, isViewingInterior } = useContext(HeroContext);
  const isMobileCapture = useSelector(getIsMobileCapture);
  const isSpinnerDisabled = useSelector(getIsSpinnerDisabled);

  const handleEngagement = debounce(() => {
    trackEvent(SPINNER_ENGAGED);
  }, 300);

  return (
    <Wrapper
      className={classNames(
        'no-zoom',
        { 'h-auto': hasSpinnerOverflow },
        { 'mobile-capture': isMobileCapture },
        { 'viewing-interior': isViewingInterior }
      )}
    >
      <HeroHeader />
      <StaticVehicle isVisible={!spinnerReady.isLoaded || isSpinnerDisabled} />
      <Container
        data-analytics-id={null}
        data-nav-section={Sections.Spinner}
        className={classNames({
          'is-error': spinnerReady.error
        })}
        id={Sections.Spinner}
        onClick={handleEngagement}
        onTouchEnd={handleEngagement}
      >
        {isSpinnerDisabled ? null : <SpinnerLoader />}
      </Container>
    </Wrapper>
  );
}

export default memo(Spinner);
